import { render, staticRenderFns } from "./CustomizeModal.vue?vue&type=template&id=d5b1873c&scoped=true&"
import script from "./CustomizeModal.vue?vue&type=script&lang=ts&"
export * from "./CustomizeModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomizeModal.vue?vue&type=style&index=0&id=d5b1873c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b1873c",
  null
  
)

export default component.exports